module.exports = __webpack_public_path__ + "static/CrimsonText-Regular-62f10d46561ed0b911d42b7510d62d74.ttf";